import Help from './Help';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';

class ImportApproach extends React.Component {

    render() {

        const { classes, approach, onChange, margin } = this.props;

        return (
            <TitledPanel height="full" title="Import Logic" margin={margin} actions={
                <Help textRef="IMPORT_APPROACH" position={false} />
            }>
                <FormControl component="fieldset" style={{ marginLeft: 12 }}>
                    <legend className={classes.hideLegend}>Import logic</legend>
                    <RadioGroup row aria-label="Import Logic" name="documentBased" value={approach} onChange={onChange}>
                        <FormControlLabel data-test="select-namespace" value="Namespace" control={<Radio color="primary" />} label="Namespace Based"
                            classes={{ label: classes.formLabelInline }}
                        />
                        <FormControlLabel data-test="select-document" value="Document" control={<Radio color="primary" />} label="Document Based"
                            classes={{ label: classes.formLabelInline }}
                        />
                    </RadioGroup>
                </FormControl>
            </TitledPanel>
        );
    }
}

ImportApproach.defaultProps = {
    margin: true
};

ImportApproach.propTypes = {
    approach: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object,
    margin: PropTypes.bool
};

export default withStyles(styles)(ImportApproach);